import { PointerSensor } from '@dnd-kit/core';
import type { PointerEvent } from 'react';

export class SmartPointerSensor extends PointerSensor {
  static activators = [
    {
      eventName: super.activators[0].eventName,
      handler: ({ nativeEvent: event }: PointerEvent) => {
        // Only activate drag for primary left-clicks on non-interactive elements
        return (
          event.isPrimary &&
          event.button === 0 &&
          !isInteractiveElement(event.target as Element)
        );
      },
    },
  ];
}

function isInteractiveElement(element: Element | null) {
  const interactiveElements = [
    'button',
    'input',
    'textarea',
    'select',
    'option',
    'a',
  ];

  for (const interactiveElement of interactiveElements) {
    if (element?.closest(interactiveElement)) {
      return true;
    }
  }

  return false;
}
